import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EditorState } from 'draft-js';

export const SMS_STATUS_KEY = 'message_state';

export interface DataObject {
  id: number;
  isClientMessage: boolean;
  value?: string;
  time: string;
  conferenceMsg: boolean;
}

export interface messages {
  messageStack: DataObject[];
  count: number;
}

export const chatStatusInitialState: messages = {
  messageStack: [
    {
      id: 0,
      isClientMessage: true,
      value: `I would like some help locating some 
      lugguage that you lost yesterday. I've been trying to call but the wait time is super long`,
      time: "2 mins ago",
      conferenceMsg: false
    }
  ],
  count: 1
};

export const messageSlice = createSlice({
  name: SMS_STATUS_KEY,
  initialState: chatStatusInitialState,
  reducers: {
    /**
     * Function for message queue
     * @param state - messageState
     * @param action - PayloadAction<DataObject>
     * @example dispatch(messageStateActions.messageQueue(value: 'Here is a link to the status of your baggage that you requested we send to your phone.Status Link', id: 10, isClientMessage: false, time: 'now', conferenceMsg: true));
     * @returns 
     */
    messageQueue(state, action: PayloadAction<DataObject>) {
      return {
        ...state,
        messageStack: [...state.messageStack, action.payload],
        count: state.count + 1
      };
    },
    /**
     * function to reset message stack from chat box
     * @example dispatch(messageStateActions.resetMessageStack());
     * @returns 
     */
    resetMessageStack() {
      return {
        ...chatStatusInitialState
      };
    }
  },
});

export const messageReducer = messageSlice.reducer;
export const messageStateActions = messageSlice.actions;

/**
 * Function to get messages
 * @param rootState - messages
 * @returns It returns messages
 * @example - const messageState = messageState(rootState)
 */
const messageState = (rootState: { message_state: messages }) => {
  return rootState[SMS_STATUS_KEY];
};

export const getMessageList = createSelector(messageState, (state) => {
  return state;
});